<template>
  <div :class="getClass()">{{ text }}</div>
</template>
<script>
import axios from 'axios'
import { ServiceBus } from '../../ServiceBus.js'
import { UtilityMixin } from '../../mixins/UtilityMixin.js'

export default {
  name: 'CellBox',
  mixins: [UtilityMixin],
  props: {
    text: {
      default: '',
      type: String,
    },
    row: {
      default: null,
      type: Object,
    },
    col: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {}
  },
  mounted() {
    const vm = this
  },
  computed: {},

  methods: {
    getClass() {
      const vm = this
      if (vm.row.targaKey.includes('|=|')) {
        return ''
      }
      if (vm.col.id === 'targa') {
        if (vm.row.targaKey.includes('|A|')) {
          if (vm.col.order == 0) {
            return 'sr_special_couple_up'
          } else {
            return 'sr_special_couple_down'
          }
        } else {
          if (vm.col.order == 0) {
            return 'sr_special_couple_down'
          } else {
            return 'sr_special_couple_up'
          }
        }
      }
      return ''
    },
  },
}
</script>
